import { render, staticRenderFns } from "./PurchaseInvoicesReportsListFilters.vue?vue&type=template&id=395f2d69&"
import script from "./PurchaseInvoicesReportsListFilters.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicesReportsListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports